<template>
  <SegmentControl
    v-model="valueModel"
    class="mb-2"
    :label="label"
    name="tournamentAvailabilityType"
    :options="$options.variants"
  />
</template>

<script>
import { emptyString } from '@/utils/factories';
import valueModel from '@/mixins/valueModel';
import SegmentControl from '@/components/atoms/form/HeraFormSegmentControl';

export default {
  components: {
    SegmentControl,
  },

  mixins: [valueModel],

  props: {
    value: {
      type: String,
      default: emptyString,
    },
    label: {
      type: String,
      default: emptyString,
    },
  },

  created() {
    this.$options.variants = [
      {
        label: this.$t(
          '_web_competitions_tournaments-tournament-type-all',
          'All'
        ),
        value: null,
      },
      {
        label: this.$t(
          '_web_competitions_tournaments-tournament-type-online',
          'Online'
        ),
        value: 'online',
      },
      {
        label: this.$t(
          '_web_competitions_tournaments-tournament-type-offline',
          'Offline'
        ),
        value: 'offline',
      },
    ];
  },
};
</script>
